// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".alert-section[data-v-641a1fd9]{border-radius:4px;padding:16px}.level--alert[data-v-641a1fd9]{background:#fff0f1;border:1px solid #db4c55;color:#000}.level--caution[data-v-641a1fd9]{background:#fff7ea;border:1px solid #f7c648;color:#000}", ""]);
// Exports
module.exports = exports;
